import { Currency, Language } from '../types/common';
import { CurrencyCodeEnum, CurrencySymbolEnum } from './enums';

export const CURRENCIES: Currency[] = [
  {
    code: CurrencyCodeEnum.USD,
    symbol: CurrencySymbolEnum.USD,
  },
  {
    code: CurrencyCodeEnum.EUR,
    symbol: CurrencySymbolEnum.EUR,
  },
];

export const LANGUAGES: Language[] = [
  {
    code: 'en',
    locale: 'en-US',
  },
  {
    code: 'es',
    locale: 'es-ES',
  },
];

export const TAG_LIST = ['high risk', 'medium risk', 'low risk'];

export const OPTIONS_LIST = [
  'Edit tags',
  'Rename',
  'Duplicate',
  'Advanced Settings',
  'Export',
  'Archive',
  'Delete',
];

export const OPTIONS_ARCHIVED_LIST = ['Rename', 'Resume', 'Export', 'Delete'];

export const COLUMNS_DUPLICATE_STRATEGY = [
  'ASSET',
  'QUANTITY',
  'LAST PRICE',
  'TOT VALUE',
  '%INV.',
] as const;

export const COLUMNS_SUMMARY = [
  'type of asset',
  'asset name',
  'quantity',
  'entry price',
  'invested',
  'bank/wallet',
] as const;

export const COLUMNS_TARGET_PRICE = ['ASSET', 'ENTRY PRICE', 'LAST PRICE'];
